import React, { Component } from "react";
import Logout from "../assets/logout.svg";
import Back from "../assets/back.svg";
// import Edit from '../assets/edit.svg'
import Plus from "../assets/plus.svg";
import EditButton from "../components/UsersEditButton";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import CustomButton from "../components/CustomButton";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../assets/cancel.svg";
import Tick from "../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../components/Paginator";
import filter from "../assets/filter.png";
import { Icon } from "@iconify/react";
import generator from "generate-password";
import refresh02 from "@iconify/icons-ci/refresh-02";
import momentjalali from "moment-jalaali";
import moment from "moment-timezone";
import copy from "copy-to-clipboard";
import {
  BaseUrl,
  Authorization,
  BaseUrlPublic,
  LogoutFunction,
  BuAppUrl,
} from "../static.js";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import warning from "../images/warning.png";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ListViewer from "../components/ListViewer";
import baselineContentCopy from "@iconify/icons-ic/baseline-content-copy";

const mobileRegex = RegExp(/09(0[0-9]|1[1-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    textAlign: "start",
    maxWidth: "200px",
  },
});

export default class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "نام کاربری",
          field: "userName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام و نام خانوادگی",
          field: "fullName",
          cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تلفن همراه",
          field: "mobile",
          cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "createdAt",
          cellRenderer: "formatDateTime",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "هشدار",
          field: "OPWarning",
          cellRenderer: "formatBool",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "fotmatEditCell",
          cellRendererParams: {
            editItem: this.editItem.bind(this),
            deleteItem: this.deleteItem.bind(this),
          },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        fotmatEditCell: EditButton,
        formatCurrency: this.formatCurrency,
        formatNumber: this.formatNumber,
        formatString: this.formatString,
        formatDateTime: this.formatDateTime,
        formatBool: this.formatBool,
      },
      ModalShow: false,
      modalType: 0,
      writingProgress: false,
      fullNameErrorText: "",
      fullNameValue: "",
      userNameErrorText: "",
      userNameValue: "",
      mobileErrorText: "",
      mobileValue: "",
      passwordErrorText: "",
      passwordValue: "sepandplus12345",
      activeStatus: true,
      fPurchaseErrorText: "",
      fPurchaseValue: "",
      tPurchaseErrorText: "",
      tPurchaseValue: "",
      downgrade: false,
      dataLoading: true,
      currentPage: 1,
      totalPages: 1,
      ModalShow1: false,
      modal1Loading: false,
      AccessModal: false,
      currentPage1: 0,
      totalPages1: 0,
      ModalShow2: false,
      CNameErrorText: "",
      CNameValue: "",
      CPhoneErrorText: "",
      CPhoneValue: "",
      writingProgress1: false,
      currentGroupId: null,
      tableHasFilter: false,
      accessList: [],
      passwordGenerated: false,
      currentUserAccess: [],
      deleteModalShow: false,
      currentDeleteItemName: "",
      currentDeleteItemId: null,
      orderProcess: [],
      selectedOrderProcess: [],
      orderProcessId: [],
      ModalShowOrderProcess: false,
      currentItemId: null,
      addProcessToItemLoading: false,
      resID: null,
      NameErrorText: "",
      NameValue: "",
      PatternsModalShow: false,
      patternColumnDefs: [
        {
          headerName: "نام الگو",
          field: "title",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "fotmatEditCell",
          cellRendererParams: {
            editItem: this.editItemPattern.bind(this),
            deleteItem: this.deleteItemPattern.bind(this),
          },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      patternRowData: [],
      isPattern: false,
      tableLoading: false,
      isChoosePattern: false,
      isCustom: false,
      selectedPattern: [],
      patternList: [],
      ModalShowSelectPattern: false,
      loadingPattern: false,
      thisWidth: 0,
      orderProcessLoading: false,
    };

    this.tableGrid = React.createRef();
    this.tableContainer = React.createRef();
    this.tableContainer1 = React.createRef();
    this.tableContainer2 = React.createRef();
    this.patternName = React.createRef();

    // this.GetAccountGroups = this.GetAccountGroups.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
    this.resetModalValues = this.resetModalValues.bind(this);
    this.resetFilterValues = this.resetFilterValues.bind(this);
    this.readBusinessUserList = this.readBusinessUserList.bind(this);
    this.readBusinessUserTypeList = this.readBusinessUserTypeList.bind(this);
    this.readOrderProcess = this.readOrderProcess.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    try {
      this.setState({
        thisWidth: window.innerWidth,
      });
    } catch (error) {}
  }

  formatDateTime(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      var zone_name = moment.tz.guess();
      let newdatetime = moment
        .tz(params.value, zone_name)
        .format("yyyy-MM-DD HH:mm")
        .toString()
        .split(" ");

      let result =
        newdatetime[1] +
        " " +
        momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD");

      return result;
    } catch (error) {
      return "-";
    }
  }

  formatString(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return params.value;
    } catch (error) {
      return "-";
    }
  }

  formatNumber(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "0";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" ریال"}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatBool(params) {
    if (params.value)
      return (
        <CustomTooltip title="این کاربر در هیچ یک از گام‌های روال سفارش به کار نرفته است">
          <img
            src={warning}
            alt=""
            style={{ height: "20px", width: "20px", objectFit: "contain" }}
          />
        </CustomTooltip>
      );
    else return "-";
  }

  componentDidMount() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    // this.setState({ loading: true });

    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ resID: result.result[0].id }, () => {
            this.readBusinessUserList(1);
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ dataLoading: false });
        }

        window.addEventListener("resize", this.updateWindowDimensions);
        this.updateWindowDimensions();
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  readBusinessUserList(page) {
    let data = {
      businessCode: this.props.match.params.id,
      page: page,
      count: 10,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "readBusinessUserList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              // dataLoading: false,
              rowData: result.result,
              totalPages: result.totalPage,
              currentPage: page,
            },
            () => {
              // this.readOrderProcess();
              this.readBusinessUserTypeList();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  readOrderProcess() {
    let businessUserType = [];
    this.state.currentUserAccess.forEach((element) => {
      businessUserType.push(element.typeId);
    });
    let data = {
      businessCode: this.props.match.params.id,
      businessUserType: businessUserType,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    this.setState({ orderProcessLoading: true });
    fetch(BaseUrl + "readOrderProcess", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("readOrderProcess:", result);
        if (result.status === 200) {
          this.setState(
            {
              orderProcess: result.result,
              orderProcessLoading: false,
            },
            () => {
              if (this.state.orderProcess.length < 1)
                this.setState({ ModalShowOrderProcess: false });
            }
          );
        } else if (result.status === 403) {
          this.setState(
            {
              orderProcess: [],
            },
            () => {
              // this.readBusinessUserTypeList();
            }
          );
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  readBusinessUserTypeList() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "readBusinessUserTypeList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({
            accessList: result.ruleList,
            dataLoading: false,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getUserInfo(id) {
    let data = {
      businessCode: this.props.match.params.id,
      businessUserId: id,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "getUserInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getUserInfo: ", result);
        if (result.status === 200) {
          let access = JSON.parse(JSON.stringify(this.state.accessList));

          result.userInfo.userType.forEach((element) => {
            access.forEach((element1) => {
              if (element1.id === element.typeId) {
                element1.value = true;

                element.typeOptions.forEach((element3) => {
                  element1.options.forEach((element2) => {
                    if (element2.id === element3) {
                      element2.value = true;
                    }
                  });
                });
              }
            });
          });

          this.setState({
            accessList: access,
            currentUserAccess: result.userInfo.userType,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onFirstPageClick() {
    this.readBusinessUserList(1);
  }

  onPreviousPageClick() {
    this.readBusinessUserList(this.state.currentPage - 1);
  }

  onNextPageClick() {
    this.readBusinessUserList(this.state.currentPage + 1);
  }

  onLastPageClick() {
    this.readBusinessUserList(this.state.totalPages);
  }

  onBack() {
    this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        // console.log('width',width);
        // console.log('tableContainer',this.tableContainer.current.getBoundingClientRect().width-10);
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          // console.log('def',def);
          if (def > cols.length) {
            let newwidth = def / cols.length;
            // console.log('newwidth',newwidth)
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            // console.log('aa');
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
        // if (width<this.tableContainer.current.getBoundingClientRect().width) params.api.sizeColumnsToFit()
      }, 50);
    } catch (error) {}
  }

  resetModalValues(id) {
    this.setState(
      {
        userNameValue: "",
        userNameErrorText: "",
        fullNameValue: "",
        fullNameErrorText: "",
        mobileValue: "",
        mobileErrorText: "",
        passwordValue: "sepandplus12345",
        passwordGenerated: false,
        currentUserAccess: [],
      },
      () => {
        this.state.rowData.forEach((element) => {
          if (element.id === id) {
            this.setState({
              userNameValue: element.userName,
              fullNameValue: element.fullName,
              mobileValue: element.mobile,
            });
          }
        });
      }
    );
  }

  onAddNewButton() {
    this.resetModalValues(0);
    // this.readBusinessUserTypeList(0);
    this.readBUTemplate();
    this.setState({ ModalShow: true, modalType: 0 });
  }

  itemDeleteConfirm() {
    let data = null;
    let apiname = "";
    if (this.state.isPattern) {
      apiname = "deleteBUTemplate";
      data = {
        businessId: this.state.resID,
        businessCode: this.props.match.params.id,
        templateId: this.state.currentDeleteItemId,
      };
    } else {
      apiname = "deleteBusinessUser";
      data = {
        businessCode: this.props.match.params.id,
        businessUserId: this.state.currentDeleteItemId,
      };
    }

    data = Object.assign(data, Authorization());

    this.setState({ deleteModalShow: false });

    fetch(BaseUrl + apiname, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          if (this.state.isPattern) {
            this.readBUTemplate();
          } else {
            this.readBusinessUserList(this.state.currentPage);
          }
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  deleteItem(e) {
    let name = "";
    this.state.rowData.forEach((element) => {
      if (element.id === e) name = element.userName;
    });
    this.setState({
      isPattern: false,
      currentDeleteItemId: e,
      currentDeleteItemName: name,
      deleteModalShow: true,
    });
  }

  editItem(e) {
    this.resetModalValues(e);
    this.getUserInfo(e);
    this.readBUTemplate();
    this.setState({ ModalShow: true, modalType: e });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onConfirm() {
    if (!this.state.userNameValue) {
      this.setState(
        { userNameErrorText: "نام کاربری نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.userNameErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ userNameErrorText: "" });
    }
    // console.log("sd");
    // if (this.state.modalType === 0 && this.state.orderProcess.length > 0) {
    //   this.setState({
    //     selectedOrderProcess: [],
    //     ModalShowOrderProcess: true,
    //   });
    // } else {

    // }

    this.createUpdateUser();
  }

  createUpdateUser() {
    let data = {
      businessCode: this.props.match.params.id,
      userNameAllocated: this.state.userNameValue,
      password: this.state.passwordValue,
      fullName: this.state.fullNameValue,
      userMobile: this.state.mobileValue,
      businessUserType: this.state.currentUserAccess,
    };

    let apiname = "createBusinessUser";
    if (this.state.modalType !== 0) {
      apiname = "updateBusinessUser";
      data = {
        businessCode: this.props.match.params.id,
        userNameAllocated: this.state.userNameValue,
        password: this.state.passwordGenerated
          ? this.state.passwordValue
          : null,
        fullName: this.state.fullNameValue,
        userMobile: this.state.mobileValue,
        businessUserId: this.state.modalType,
        businessUserType: this.state.currentUserAccess,
      };
    }

    data = Object.assign(data, Authorization());
    console.log(data);
    // console.log("fsdkfhsdfkshdfjk");
    fetch(BaseUrl + "" + apiname, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200 || result.status === 201) {
          this.setState({ ModalShow: false });
          this.readBusinessUserList(this.state.currentPage);
          if (apiname === "createBusinessUser") {
            this.setState(
              {
                currentItemId: result.newItemId,
                selectedOrderProcess: [],
                ModalShowOrderProcess: true,
              },
              () => {
                this.readOrderProcess();
              }
            );
          }
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onConfirmOrderProcess(listt) {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      itemId: this.state.currentItemId,
      itemType: "businessUser",
      orderProcessList: listt,
    };
    data = Object.assign(data, Authorization());

    console.log(data);
    this.setState({ addProcessToItemLoading: true });
    fetch(BaseUrl + "addNewItemToOP", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("result");
        console.log(result);
        if (result.status === 200) {
          var list = JSON.parse(JSON.stringify(this.state.rowData));
          // console.log(this.state.rowData);
          if (listt.length > 0) {
            list.forEach((element) => {
              if (element.id === this.state.currentItemId) {
                element.OPWarning = false;
              }
            });
          }

          this.setState({
            rowData: list,
            selectedOrderProcess: [],
            ModalShowOrderProcess: false,
            addProcessToItemLoading: false,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error("عملیات با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ addProcessToItemLoading: false });
      });
  }

  hideModal1() {
    this.setState({ ModalShow1: false });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  resetFilterValues() {
    this.setState({
      CNameErrorText: "",
      CNameValue: "",
      CPhoneErrorText: "",
      CPhoneValue: "",
    });
  }

  onFilterClick() {
    this.setState({ ModalShow2: true });
  }

  onFilterClear() {
    this.resetFilterValues();
    this.reportSpecialCustomer(this.state.currentGroupId, null, null, 1);
  }

  onCustomerFilterConfirm() {
    if (this.state.CPhoneValue && !mobileRegex.test(this.state.CPhoneValue)) {
      this.setState({ CPhoneErrorText: "شماره موبایل نامعتبر است" }, () => {
        toast.error(this.state.CPhoneErrorText, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
      return;
    } else {
      this.setState({ CPhoneErrorText: "" });
    }

    this.setState({ ModalShow2: false });
    this.reportSpecialCustomer(
      this.state.currentGroupId,
      this.state.CNameValue,
      this.state.CPhoneValue,
      1
    );
  }

  changeNewPassword() {
    let pass = generator.generate({
      length: 8,
      numbers: true,
    });
    this.setState({ passwordValue: pass });
  }

  onShowAccess() {
    console.log(this.state.currentUserAccess);
    let access = JSON.parse(JSON.stringify(this.state.accessList));

    access.forEach((element1) => {
      element1.value = false;
    });

    this.state.currentUserAccess.forEach((element) => {
      access.forEach((element1) => {
        if (element1.id === element.typeId) {
          element1.value = true;

          element.typeOptions.forEach((element3) => {
            element1.options.forEach((element2) => {
              if (element2.id === element3) {
                element2.value = true;
              }
            });
          });
        }
      });
    });

    this.setState({ accessList: access }, () => {
      this.setState({
        isPattern: false,
        AccessModal: true,
        currentDeleteItemId: null,
      });
    });
  }

  onResetPassword() {
    let pass = generator.generate({
      length: 8,
      numbers: true,
    });
    this.setState({ passwordValue: pass }, () => {
      this.setState({ passwordGenerated: true });
    });
  }

  onSaveAccess() {
    let newaccess = [];

    this.state.accessList.forEach((element) => {
      if (element.value) {
        let options = [];
        element.options.forEach((element1) => {
          if (element1.value) options.push(element1.id);
        });
        newaccess.push({ typeId: element.id, typeOptions: options });
      }
    });

    this.setState({ currentUserAccess: newaccess, AccessModal: false }, () => {
      // console.log(newaccess);
      setTimeout(() => {
        let access = JSON.parse(JSON.stringify(this.state.accessList));
        access.forEach((element) => {
          element.value = false;
          element.options.forEach((element1) => {
            element1.value = false;
          });
        });
        this.setState({ accessList: access });
      }, 500);
    });
  }

  onSaveAccessPattern() {
    let newaccess = [];

    this.state.accessList.forEach((element) => {
      if (element.value) {
        let options = [];
        element.options.forEach((element1) => {
          if (element1.value) options.push(element1.id);
        });
        newaccess.push({ typeId: element.id, typeOptions: options });
      }
    });

    if (!this.state.NameValue) {
      this.setState({ NameErrorText: "لطفاً نام الگو را مشخص کنید" });
      return;
    } else this.setState({ NameErrorText: "" });

    let apiname = "createBUTemplate";
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      title: this.state.NameValue,
      template: newaccess,
    };
    if (this.state.currentDeleteItemId) {
      apiname = "updateBUTemplate";
      data = {
        businessId: this.state.resID,
        businessCode: this.props.match.params.id,
        title: this.state.NameValue,
        templateId: this.state.currentDeleteItemId,
        template: newaccess,
      };
    }

    data = Object.assign(data, Authorization());

    console.log(data);
    this.setState({ writingProgress: true });
    fetch(BaseUrl + apiname, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          toast.success("عملیات با موفقیت انجام شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState(
            {
              writingProgress: false,
              AccessModal: false,
            },
            () => {
              this.readBUTemplate();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ writingProgress: false });
          toast.error("عملیات با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingProgress: false });
      });

    // this.setState({ currentUserAccess: newaccess, AccessModal: false },()=>{
    //   // console.log(newaccess);
    //   // setTimeout(() => {
    //   //   let access = JSON.parse(JSON.stringify(this.state.accessList));
    //   //   access.forEach((element) => {
    //   //     element.value = false;
    //   //     element.options.forEach((element1) => {
    //   //       element1.value = false;
    //   //     });
    //   //   });
    //   //   this.setState({ accessList: access });
    //   // }, 500);
    // });
  }

  readBUTemplate() {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    console.log(data);
    this.setState({ tableLoading: true });
    fetch(BaseUrl + "readBUTemplate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({
            tableLoading: false,
            patternRowData: result.result,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else if (result.status === 403) {
          this.setState({
            tableLoading: false,
            patternRowData: [],
          });
        } else {
          this.setState({ tableLoading: false });
          toast.error("عملیات با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ tableLoading: false });
      });
  }

  editItemPattern(id) {
    let access = JSON.parse(JSON.stringify(this.state.accessList));
    let temp = [];
    let title = "";
    this.state.patternRowData.forEach((element) => {
      if (element.id === id) {
        temp = element.template;
        title = element.title;
      }
    });

    temp.forEach((element) => {
      access.forEach((element1) => {
        if (element1.id === element.typeId) {
          element1.value = true;

          element.typeOptions.forEach((element3) => {
            element1.options.forEach((element2) => {
              if (element2.id === element3) {
                element2.value = true;
              }
            });
          });
        }
      });
    });

    this.setState({
      accessList: access,
      currentUserAccess: temp,
      AccessModal: true,
      isPattern: true,
      NameValue: title,
      currentDeleteItemId: id,
    });
  }

  deleteItemPattern(id) {
    let name = "";
    this.state.patternRowData.forEach((element) => {
      if (element.id === id) name = element.title;
    });
    this.setState({
      isPattern: true,
      currentDeleteItemId: id,
      currentDeleteItemName: name,
      deleteModalShow: true,
    });
  }

  onFirstDataRendered2(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer2.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer2.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  onPatterns() {
    this.setState({ PatternsModalShow: true }, () => {
      this.readBUTemplate();
    });
  }

  onNewPattern() {
    let access = JSON.parse(JSON.stringify(this.state.accessList));
    access.forEach((element) => {
      element.value = false;
      element.options.forEach((element1) => {
        element1.value = false;
      });
    });

    this.setState(
      {
        isPattern: true,
        AccessModal: true,
        currentDeleteItemId: null,
        NameValue: "",
        accessList: access,
      },
      () => {
        this.patternName.current.focus();
      }
    );
  }

  onShowPattern() {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    console.log(data);
    this.setState({ ModalShowSelectPattern: true, loadingPattern: true });
    fetch(BaseUrl + "readBUTemplate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("readBUTemplate: ", result);
        if (result.status === 200) {
          this.setState({
            loadingPattern: false,
            patternList: result.result,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ tableLoading: false });
          toast.error("عملیات با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ tableLoading: false });
      });
  }

  onConfirmPattern(id) {
    // console.log(id);
    let access = JSON.parse(JSON.stringify(this.state.accessList));

    access.forEach((element) => {
      element.value = false;
      element.options.forEach((element1) => {
        element1.value = false;
      });
    });
    // access.forEach((element1) => {
    //   element1.value = false;
    //   element1.options.forEach((element2) => {
    //     element2.value = false;
    //   });
    // });
    // this.setState({ accessList: access }, () => {
    //   // access = JSON.parse(JSON.stringify(this.state.accessList));

    // });
    this.state.patternRowData.forEach((element0) => {
      if (id[0] === element0.id) {
        element0.template.forEach((element) => {
          access.forEach((element1) => {
            if (element1.id === element.typeId) {
              element1.value = true;

              element.typeOptions.forEach((element3) => {
                element1.options.forEach((element2) => {
                  if (element2.id === element3) {
                    element2.value = true;
                  }
                });
              });
            }
          });
        });
      }
    });

    this.setState({ ModalShowSelectPattern: false, accessList: access });
  }

  copyURLClick() {
    copy(BuAppUrl + "Login/" + this.props.match.params.id);
    toast.success("آدرس کپی شد", {
      position: toast.POSITION.BOTTOM_RIGHT,
      hideProgressBar: true,
      autoClose: 6000,
      toastClassName: "toast",
    });
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
                // data-tip="خروج"
                // data-place="bottom"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">کاربران</div>
          <div className="RestaurantsListSubTitle">
            ایجاد کابر جدید و اختصاص سطح دسترسی
          </div>
        </div>
        <div className="pageContents" ref={this.tableContainer}>
          {!this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: this.state.thisWidth > 500 ? "row" : "column",
                justifyContent: "space-between",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: this.state.thisWidth > 500 ? "0px" : "10px",
                }}
              >
                <CustomButton
                  title="کاربر جدید"
                  imgHeight={20}
                  imgWidth={25}
                  flexDirection="row-reverse"
                  minHeight="35px"
                  img={Plus}
                  onClick={this.onAddNewButton.bind(this)}
                />
                <div style={{ minWidth: "5px" }} />
                <CustomButton
                  title="تعریف الگو مجوز و دسترسی"
                  whiteSpace="nowrap"
                  // imgHeight={20}
                  // imgWidth={25}
                  flexDirection="row-reverse"
                  minHeight="35px"
                  // img={Plus}
                  onClick={this.onPatterns.bind(this)}
                />
              </div>

              <div style={{ width: "fit-content" }}>
                <CustomButton
                  title="کپی آدرس صفحه ورود کاربران"
                  icoHeight={20}
                  icoWidth={20}
                  icoMarginLeft="5px"
                  flexDirection="row-reverse"
                  minHeight="35px"
                  whiteSpace="nowrap"
                  // img={Plus}
                  ico={baselineContentCopy}
                  onClick={this.copyURLClick.bind(this)}
                />
              </div>
            </div>
          )}
          {!this.state.dataLoading && (
            <div className="tableContainer ag-theme-alpine">
              <AgGridReact
                enableRtl={true}
                autoHeight={true}
                animateRows={true}
                enableBrowserTooltips={true}
                tooltipMouseTrack={true}
                suppressSizeToFit={false}
                columnDefs={this.state.columnDefs}
                localeText={this.state.gridLocaleText}
                rowData={this.state.rowData}
                suppressDragLeaveHidesColumns={true}
                suppressMovable={true}
                skipHeaderOnAutoSize={false}
                // onGridReady={this.onGridReady.bind(this)}
                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                rowHeight={window.innerWidth <= 587 ? 40 : 50}
                headerHeight={window.innerWidth <= 587 ? 40 : 50}
                frameworkComponents={this.state.frameworkComponents}
                // onRowClicked={this.onGridRowClicked.bind(this)}
                // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                ref={this.tableGrid}
                enableCellTextSelection={true}
                ensureDomOrder={true}
              />
            </div>
          )}
          {!this.state.dataLoading && (
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paginator
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                onFirstPageClick={this.onFirstPageClick.bind(this)}
                onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                onNextPageClick={this.onNextPageClick.bind(this)}
                onLastPageClick={this.onLastPageClick.bind(this)}
              />
            </div>
          )}

          {this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
        </div>

        <Modal
          show={this.state.ModalShow}
          size="md"
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">کاربر جدید</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div
                  className="settingLabel"
                  style={{ textAlign: "right", whiteSpace: "noWrap" }}
                >
                  نام کاربری
                </div>
                <Form.Control
                  maxLength="50"
                  className={
                    this.state.userNameErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter"
                      : "inputStyleForm textAlignCenter"
                  }
                  style={{ direction: "ltr", maxWidth: "200px" }}
                  placeholder="نام کاربری"
                  type="text"
                  name="userNameValue"
                  disabled={this.state.modalType !== 0}
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.userNameValue}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    کلمه عبور
                    {(this.state.modalType === 0 ||
                      (this.state.modalType !== 0 &&
                        this.state.passwordGenerated)) && (
                      <Icon
                        icon={refresh02}
                        style={{
                          color: "var(--brown1)",
                          fontSize: "24px",
                          margin: "0px 10px",
                          cursor: "pointer",
                        }}
                        onClick={this.changeNewPassword.bind(this)}
                      />
                    )}
                  </div>
                </div>
                {(this.state.modalType === 0 ||
                  (this.state.modalType !== 0 &&
                    this.state.passwordGenerated)) && (
                  <Form.Control
                    maxLength="50"
                    className={
                      this.state.passwordErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter"
                        : "inputStyleForm textAlignCenter"
                    }
                    style={{ maxWidth: "200px" }}
                    placeholder="کلمه عبور"
                    disabled
                    type="text"
                    name="passwordValue"
                    onChange={this.textHandleChange.bind(this)}
                    value={this.state.passwordValue}
                  />
                )}

                {this.state.modalType !== 0 &&
                  !this.state.passwordGenerated && (
                    <div style={{ width: "100%", maxWidth: "200px" }}>
                      <CustomButton
                        title="کلمه عبور جدید"
                        imgHeight={20}
                        imgWidth={25}
                        minHeight="35px"
                        onClick={this.onResetPassword.bind(this)}
                      />
                    </div>
                  )}
              </div>

              <div className="settingItemContainer">
                <div
                  className="settingLabel"
                  style={{ textAlign: "right", whiteSpace: "noWrap" }}
                >
                  نام و نام خانوادگی
                </div>
                <Form.Control
                  maxLength="50"
                  className={
                    this.state.fullNameErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter"
                      : "inputStyleForm textAlignCenter"
                  }
                  style={{ maxWidth: "200px" }}
                  placeholder="نام و نام خانوادگی"
                  type="text"
                  name="fullNameValue"
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.fullNameValue}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  تلفن همراه
                </div>
                <Form.Control
                  maxLength="11"
                  className={
                    this.state.mobileErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter"
                      : "inputStyleForm textAlignCenter"
                  }
                  style={{ maxWidth: "200px" }}
                  placeholder="تلفن همراه"
                  type="text"
                  name="mobileValue"
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.mobileValue}
                />
              </div>

              {/* <div
                className="settingItemContainer"
                style={{ flexDirection: "column" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="settingLabel">انتخاب الگوی مجوز و دسترسی</div>

                  <BootstrapSwitchButton
                    checked={this.state.isChoosePattern}
                    onChange={(checked) => {
                      this.setState({
                        isChoosePattern: checked,
                        isCustom: checked ? false : this.state.isCustom,
                      });
                    }}
                    onlabel="بله"
                    offlabel="خیر"
                    onstyle="primary"
                    offstyle="warning"
                    width={75}
                  />
                </div>
                <div style={{ width: "100%", marginTop: "10px" }}>
                  <CustomButton
                    title="مجوزها و دسترسی‌ها "
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    onClick={this.onShowAccess.bind(this)}
                  />
                </div>
              </div> */}
              <div
                className="settingItemContainer"
                // style={{ flexDirection: "column" }}
              >
                <div style={{ width: "100%" }}>
                  <CustomButton
                    title="مجوزها و دسترسی‌ها "
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    onClick={this.onShowAccess.bind(this)}
                  />
                </div>
              </div>

              {/* <div className="settingItemContainer"></div> */}
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.AccessModal}
          size="md"
          backdrop="static"
          backdropClassName="backdropClassName"
          animation={true}
          onHide={() => {
            this.setState({ AccessModal: false });
          }}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">دسترسی و مجوزها</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              {this.state.isPattern && (
                <div className="settingItemContainer">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="settingLabel">نام الگو</div>
                    <div style={{ flex: "1" }} />
                    <div>
                      <Form.Control
                        maxLength="50"
                        className={
                          this.state.NameErrorText !== ""
                            ? "inputStyleForm inputError textAlignCenter"
                            : "inputStyleForm textAlignCenter"
                        }
                        style={{ minWidth: "200px" }}
                        // placeholder="نام"
                        type="text"
                        name="NameValue"
                        onChange={this.textHandleChange.bind(this)}
                        value={this.state.NameValue}
                        ref={this.patternName}
                      />
                    </div>
                  </div>
                </div>
              )}

              {!this.state.isPattern && (
                <CustomButton
                  title="انتخاب از الگوها"
                  loading={this.state.writingProgress}
                  minHeight="35px"
                  onClick={this.onShowPattern.bind(this)}
                />
              )}

              {this.state.accessList.map((item, i) => {
                return (
                  <div
                    key={i}
                    className="settingItemContainer"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: i === 0 ? "10px" : "0px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="settingLabel"
                        style={{ whiteSpace: "noWrap", textAlign: "right" }}
                      >
                        {item.titleFa}
                      </div>
                      <BootstrapSwitchButton
                        checked={item.value}
                        onChange={(checked) => {
                          let access = JSON.parse(
                            JSON.stringify(this.state.accessList)
                          );
                          access.forEach((element) => {
                            if (element.id === item.id) {
                              if (!element.value) element.value = true;
                              else element.value = false;
                            }
                          });
                          this.setState({ accessList: access });
                        }}
                        onlabel="بله"
                        offlabel="خیر"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>
                    {item.value &&
                      item.options.map((item1, i1) => {
                        return (
                          <div
                            key={i1}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                              justifyContent: "space-between",
                              alignItems: "center",
                              margin: "10px 0px",
                            }}
                          >
                            <div
                              className="settingLabel"
                              style={{
                                fontSize: "12px",
                                textAlign: "right",
                              }}
                            >
                              {item1.titleFa}
                            </div>
                            <BootstrapSwitchButton
                              checked={item1.value}
                              onChange={(checked) => {
                                let access = JSON.parse(
                                  JSON.stringify(this.state.accessList)
                                );
                                access.forEach((element) => {
                                  if (element.id === item.id) {
                                    element.options.forEach((element1) => {
                                      if (element1.id === item1.id) {
                                        if (!element1.value)
                                          element1.value = true;
                                        else element1.value = false;
                                      }
                                    });
                                  }
                                });
                                this.setState({ accessList: access });
                              }}
                              onlabel="دارد"
                              offlabel="ندارد"
                              onstyle="primary"
                              offstyle="warning"
                              width={75}
                            />
                          </div>
                        );
                      })}
                  </div>
                );
              })}
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={() => {
                    if (this.state.isPattern) this.onSaveAccessPattern();
                    else this.onSaveAccess();
                  }}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  disabled={this.state.writingProgress}
                  onClick={() => {
                    this.setState({ AccessModal: false }, () => {
                      setTimeout(() => {
                        let access = JSON.parse(
                          JSON.stringify(this.state.accessList)
                        );
                        access.forEach((element) => {
                          element.value = false;
                          element.options.forEach((element1) => {
                            element1.value = false;
                          });
                        });
                        this.setState({ accessList: access });
                      }, 500);
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.deleteModalShow}
          animation={false}
          onHide={() => this.setState({ deleteModalShow: false })}
          centered
        >
          <div className="dialogBox">
            اطمینان از حذف "{this.state.currentDeleteItemName}"؟
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="خیر"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={() => this.setState({ deleteModalShow: false })}
                />
              </div>
              <div style={{ minWidth: "5px" }} />
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="بله"
                  // loading={this.state.deleteLoading}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.itemDeleteConfirm.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          show={this.state.ModalShowOrderProcess}
          animation={true}
          size="sm"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={() => {
            this.setState({ ModalShowOrderProcess: false });
          }}
          centered
        >
          <ListViewer
            listType="orderProcess"
            title="برای کاربر روال انتخاب کنید"
            currentSelected={this.state.selectedOrderProcess}
            list={this.state.orderProcess}
            loading={this.state.orderProcessLoading}
            buttonLoading={this.state.addProcessToItemLoading}
            onConfirmOrderProcess={this.onConfirmOrderProcess.bind(this)}
            hideModal={() => {
              this.setState({ ModalShowOrderProcess: false });
            }}
          />
        </Modal>

        <Modal
          show={this.state.ModalShowSelectPattern}
          animation={true}
          size="sm"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={() => {
            this.setState({ ModalShowSelectPattern: false });
          }}
          centered
        >
          <ListViewer
            listType="pattern"
            title="انتخاب الگوی مجوز و دسترسی"
            // currentSelected={this.state.selectedPattern}
            currentSelected={[]}
            list={this.state.patternRowData}
            // list={[{ title: "1" }, { title: "2" }, { title: "3" }]}
            loading={false}
            buttonLoading={this.state.addProcessToItemLoading}
            onConfirmPattern={this.onConfirmPattern.bind(this)}
            hideModal={() => {
              this.setState({ ModalShowSelectPattern: false });
            }}
          />
        </Modal>

        <Modal
          show={this.state.PatternsModalShow}
          animation={true}
          backdrop="static"
          backdropClassName="backdropClassName"
          contentClassName="contanetStyleModal"
          onHide={() => {
            this.setState({ PatternsModalShow: false });
          }}
          centered
        >
          <div className="RestaurantsListTitle">الگوهای مجوز و دسترسی</div>
          <div
            className="pageContents"
            style={{
              width: "90vw",
              maxWidth: "800px",
              height: "auto",
              alignItems: "center",
            }}
            ref={this.tableContainer2}
          >
            {this.state.tableLoading && (
              <div
                style={{
                  minHeight: "45vh",
                  height: "45vh",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <WhisperSpinner
                  size={30}
                  color="var(--brown1)"
                  frontColor="var(--brown1)"
                  backColor="var(--brown1)"
                  loading={true}
                />
              </div>
            )}
            {!this.state.tableLoading && (
              <div style={{ alignSelf: "start" }}>
                <CustomButton
                  title="الگوی جدید"
                  imgHeight={20}
                  imgWidth={25}
                  flexDirection="row-reverse"
                  minHeight="35px"
                  img={Plus}
                  onClick={this.onNewPattern.bind(this)}
                />
              </div>
            )}
            {!this.state.tableLoading && (
              <div
                className="tableContainer ag-theme-alpine"
                style={{ minHeight: "45vh", height: "45vh" }}
              >
                <div
                  style={{
                    flex: "1",
                    width: "100%",
                    flexGrow: 1,
                    flexShrink: 0,
                    flexBasis: 0,
                  }}
                >
                  <AgGridReact
                    enableRtl={true}
                    autoHeight={true}
                    animateRows={true}
                    enableBrowserTooltips={true}
                    tooltipMouseTrack={true}
                    suppressSizeToFit={false}
                    columnDefs={this.state.patternColumnDefs}
                    localeText={this.state.gridLocaleText}
                    rowData={this.state.patternRowData}
                    suppressDragLeaveHidesColumns={true}
                    suppressMovable={true}
                    skipHeaderOnAutoSize={false}
                    onFirstDataRendered={this.onFirstDataRendered2.bind(this)}
                    rowHeight={window.innerWidth <= 587 ? 40 : 50}
                    headerHeight={window.innerWidth <= 587 ? 40 : 50}
                    frameworkComponents={this.state.frameworkComponents}
                    enableCellTextSelection={true}
                    ensureDomOrder={true}
                  ></AgGridReact>
                </div>
              </div>
            )}

            <div
              style={{
                width: "100%",
                maxWidth: "250px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="بستن"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={() => {
                    this.setState({ PatternsModalShow: false });
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>

        {/* <ReactTooltip className="tooltipContent" effect="solid" clickable /> */}
      </div>
    );
  }
}
